<template>
  <div>
    <common-dialog ref="dialog" width="430px" center title="导入 图片" @closed="onClosed">
      <template slot="form">
        <div style="text-align: center;margin-bottom: 30px;">
          <div style="margin-top: 15px;">
            <import-file :upload-url="api.importPhoto" text="选择压缩文件" accept=".zip,.7z,.rar" @uploaded="uploaded" />
          </div>
          <div class="pic_tip">
            <div>图片格式：jpg/jpeg/png，文件命名规则：身份证号_证件照.jpg、身份证号_电子签名.png...</div>
            <div>例如：440507xxxxxxxx2000_证件照.jpg、440507xxxxxxxx2000_电子签名.png</div>
            <div>支持 .zip .7z .rar 格式的文件。</div>
          </div>
        </div>
      </template>
    </common-dialog>
  </div>
</template>
<script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
  import importFile from "@/components/common/files/importFile";

  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
      importFile,
    },
    data() {
      return {
        api: require("@/api/schoolmanage/coach").default,
        attach: require("@/api/common/attach").default,
      };
    },
    computed: {},
    methods: {
      uploaded(res) {
        console.log("uploaded", res);
        if (res.Code != 0) {
          this.$message.error(res.Msg);
        } else {
          this.$emit("upload-success");
          this.close(true);
        }
      },
      onClosed() {
        
      },
    },
  };
</script>
<style lang="scss" scoped>
.pic_tip {
  margin-top: 10px;
  text-align:left;
  div {
    margin-top: 5px;
  }
}
</style>